/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ErrorName from '../../../../core/error/error-name';

/**
 * @import { FileArchiveManager as IFileArchiveManager } from '../../../../core/file/archive'
 */

/**
 * Triviální správce souborových archivů pro webovou platformu.
 * @implements {IFileArchiveManager}
 */
export default class FileArchiveManager {
  /** @type {IFileArchiveManager['getVolume']} */
  getVolume(path) {
    return new Promise(() => {
      const error = new Error('No entry exists.');
      error.name = ErrorName.NotFoundError;
      throw error;
    });
  }
}
